<script setup lang="ts">
import type { TutorBillingTableColumn, TutorBillingTableRow } from '../model/interfaces'

import { BadgeNew } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'

import { TUTOR_BILLING_TABLE_TONE_TEXT } from '../config/tutor-billing'

defineOptions({
  name: 'TutorBillingFieldsTable',
})

defineProps<{
  columns: TutorBillingTableColumn[]
  rows: TutorBillingTableRow[]
}>()
</script>

<template>
  <AppTable
    class="rounded-table tutor-billing-fields-table"
    :paginated="false"
    fixed
  >
    <template #head>
      <AppTr>
        <AppTh class="tutor-billing-fields-table__head tutor-billing-fields-table__head--field">
          <AppText
            name="body1-medium"
            color="slate-900"
          >
            Field
          </AppText>
        </AppTh>
        <AppTh
          v-for="column in columns"
          :key="column.key"
          :class="['tutor-billing-fields-table__head', `tutor-billing-fields-table__head--${column.tone ?? 'default'}`]"
        >
          <AppText
            name="body1-medium"
            :color="column.tone === 'accent' ? TUTOR_BILLING_TABLE_TONE_TEXT.accent.color : 'slate-900'"
          >
            {{ column.label }}
          </AppText>
        </AppTh>
      </AppTr>
    </template>

    <template #body>
      <AppTr
        v-for="row in rows"
        :key="row.key"
      >
        <AppTd class="medium">
          <AppText
            name="body1"
            color="slate-900"
          >
            {{ row.label }}
          </AppText>
        </AppTd>
        <AppTd
          v-for="(cell, index) in row.cells"
          :key="index"
          :class="['medium', 'tutor-billing-fields-table__value', `tutor-billing-fields-table__value--${cell.tone ?? 'default'}`]"
        >
          <span class="tutor-billing-fields-table__content">
            <AppText
              :name="TUTOR_BILLING_TABLE_TONE_TEXT[cell.tone ?? 'default'].name"
              :color="TUTOR_BILLING_TABLE_TONE_TEXT[cell.tone ?? 'default'].color"
              class="tutor-billing-fields-table__text"
              :title="cell.value"
            >
              {{ cell.value }}
            </AppText>
            <BadgeNew v-if="cell.isChanged" />
          </span>
        </AppTd>
      </AppTr>
    </template>
  </AppTable>
</template>

<style scoped lang="scss" src="./TutorBillingFieldsTable.scss" />
